import { useStyles } from '@archipro-design/aria';
import { COLUMN_WIDTH_100 } from '@modules/page-builder/config/column-constants';
import type { ImageColumnProps } from '@modules/page-builder/types';
import DetailSingleImage from '../detail-single-image-shell/DetailSingleImageShell';
import { SingleImageContainer } from '../../common/pagebuilder.style';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import ImageWithPaintPicker from '../../common/image-with-paint-picker/ImageWithPaintPicker';
import { ImageModuleExtraSpacing } from '@modules/page-builder/component/detail-mobile/detail-modules/DetailModules.style';

interface SingleImageModuleProps {
    column: ImageColumnProps;
}

const SingleImageModule = ({ column }: SingleImageModuleProps) => {
    const { css } = useStyles();

    if (!column.imageUrl) {
        return null;
    }

    return (
        <div className={css(SingleImageContainer, ImageModuleExtraSpacing)}>
            <DetailSingleImage
                caption={column.caption}
                libraryImage={column?.libraryImage}
                tags={column.tags}
                uniqueApprovedTags={column.uniqueApprovedTags}
                imageURL={column.imageUrl}
                dimension={column.dimension}
            >
                <ImageWithPaintPicker
                    src={column.imageUrl}
                    width={column.dimension.width}
                    height={column.dimension.height}
                    layout={'fill'}
                    objectFit={'cover'}
                    sizes={getImagesSizes(COLUMN_WIDTH_100)}
                    alt={column.caption || column?.libraryImage?.Title || ''}
                />
            </DetailSingleImage>
        </div>
    );
};

export default SingleImageModule;
